// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DWzok","container":"styles_container__FXl2v","checkmark":"styles_checkmark__muSre"};